<template>
  <li>
    <router-link
      :to="{name: 'client_profile', params: {clientId: userClient.client.id}}"
      class="q-px-xs q-py-sm flex items-center"
    >
      <star :user-client="userClient" class="on-left" />
      {{ $filters.clientName(userClient.client) }}
      <post-count-chip :count="totalUnreviewed" type="unreviewed" size="sm" outline />
      <post-count-chip :count="totalEscalated" type="escalated" size="sm" outline />
    </router-link>
  </li>
</template>

<style lang="scss" scoped>
@import '../styles/quasar.variables.scss';

a {
    &:hover, &.router-link-active {
        border-radius: 4px;
    }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { UserClient } from '@/type';
import { name as clientNameFilter } from '../client/client-filter';
import Star from './Star.vue';
import PostCountChip from './PostCountChip.vue';

export default defineComponent({
  components: { Star, PostCountChip },
  props: {
    userClient: {
      type: Object as () => UserClient,
    },
  },
  computed: {
    totalUnreviewed(): number {
      return this.userClient.client.totalUnreviewed;
    },
    totalEscalated(): number {
      return this.userClient.client.totalEscalated;
    },
  },
  filters: {
    clientName: clientNameFilter,
  },
});
</script>
